
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

require('spark-bootstrap');
require('./echo-bootstrap');

require('./components/bootstrap');

import store from './vuex/store';

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// if (!_.pluck) {
//   _.pluck = function(obj, key) {
//     return _.map(obj, _.property(key));
//   };
// }

if (process.env.NODE_ENV == 'production') {
  Vue.config.devtools = false;
}

var app = new Vue({
    mixins: [require('spark')],
    store,

    created() {
        this.listen()
    },

    methods: {
        listen() {
            let self = this;
            Echo.private('import-status')
                .listen('ImportQueued', function (e) {
                    self.$store.commit('client/ADD_TO_IMPORTING', e.account);
                })
                .listen('QueuedImportCompleted', function (e) {
                    self.$store.commit('client/REMOVE_FROM_IMPORTING', e.account);
                })
                .listen('QueuedImportFailed', function (e) {
                    self.$store.commit('client/REMOVE_FROM_IMPORTING', e.account);
                });
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js